import React, { useState } from 'react'
import { useOrganization } from '../context/OrganizationContext';
import { useFirebaseDoc } from '../hooks/firebaseHooks';
import { COLLECTIONS } from '../utils/shared/constants';
import { Deal } from '../models/shared/Deal';
import { Button } from 'react-bootstrap';
import DealModal from './modals/DealModal';
import { Link } from 'react-router-dom';

interface Props {
    dealId: string;
    path?: string;
    label?: React.ReactNode;
}

export default function DealLink(props: Props) {
    const { orgId } = useOrganization();
    const [openModal, setOpenModal] = useState(false);
    const [deal] = useFirebaseDoc<Deal>(`${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.DEALS}/${props.dealId}`);
    let label = props.label || deal?.name || '...';

    if (props.path) {
        let finalPath = props.path
        if (!finalPath.endsWith('/')) {
            finalPath += '/';
        }
        finalPath += props.dealId;
        return <Link to={finalPath}>{label}</Link>
    }

    return (
        <>
            <Button variant='link' className="text-start p-0 " onClick={() => setOpenModal(true)}>
                {label}
            </Button>
            {openModal && deal && <DealModal deal={deal} onClose={() => setOpenModal(false)} />}
        </>
    )
}
